import Masthead from './masthead';
import JobsThatScale from './jobs-that-scale';
import Advertising from './advertising';
import Testimonials from './testimonials';
import Banners from './banners';
import ForEmployers from './for-employers';
import NewJobPostings from './new-job-postings';

module.exports = {
  Masthead,
  JobsThatScale,
  Advertising,
  Testimonials,
  Banners,
  ForEmployers,
  NewJobPostings
};
